const ShareholderTypes = {
	Individual: 1,
	Joint: 2,
	OnBehalfOfIndividual: 3,
	OnBehalfOfOrg: 4
};

const getLabel = value => {
	switch (value) {
		case ShareholderTypes.Individual:
			return "For Myself";
		case ShareholderTypes.Joint:
			return "Jointly with another person or persons";
		case ShareholderTypes.OnBehalfOfIndividual:
			return "For another individual";
		case ShareholderTypes.OnBehalfOfOrg:
			return "On behalf of a company, society, or other incorporated organisation";
		default:
			return "Unknown";
	}
};

export default ShareholderTypes;
export {ShareholderTypes as values, getLabel};
